import { TableCell } from "@mui/material";
import { resolvePaymentTransactionStatus } from "./AppUtils";

interface Props {
  isRefunded?: boolean;
  isCancelled?: boolean;
  refundInitiated?: boolean;
  cancelOrRefund?: boolean;
  status?: string;
  transactionTypeId?: number;
  handleClick?: () => void;
  renderAsColumn?: boolean;
  alignText?: "left" | "center" | "right" | "justify" | "inherit";
}

export default function PaymentStatusColumn({
  isRefunded = false,
  isCancelled = false,
  cancelOrRefund = false,
  status,
  refundInitiated = false,
  transactionTypeId,
  handleClick,
  renderAsColumn = true,
  alignText = 'left'
}: Props) {

  const { text, color } = resolvePaymentTransactionStatus({
    isRefunded : isRefunded ?? false,
    isCancelled : isCancelled ?? false,
    cancelOrRefund : cancelOrRefund ?? false,
    status : status,
    refundInitiated : refundInitiated ?? false,
    transactionTypeId : transactionTypeId,
  });

  return renderAsColumn ? (
    <TableCell onClick={handleClick} align={alignText} style={{ color: color, whiteSpace: 'nowrap' }} >
      {text}
    </TableCell>
  ) : (
    <label style={{ color: color }}>{text}</label>
  );
}